@if (variants().length) {
  @if (!showImages()) {
    <div class="variant-wrapper color-counts">
      <p (mouseenter)="onShowImages()">
        {{
          variants().length === 1
            ? '1 Color'
            : variants().length +
              '
                Colors'
        }}
      </p>
    </div>
  } @else {
    <div class="variant-wrapper">
      <div class="variant-viewer-container-wrapper" (click)="$event.stopPropagation()">
        @if (showNavigationButtons()) {
          <button class="prev-btn" type="button" (click)="navigationLeft()">
            <img src="/assets/images/carousel-arrow-left.svg" alt="Previous" />
          </button>
        }
        <div class="variant-viewer-container" #scrollAbleContainer>
          @for (variant of variants(); track variant.product_id) {
            <div class="variant-image-container" [routerLink]="['/products/' + (variant?.url_path || '')]">
              <img [src]="variant?.image" [alt]="variant?.color || 'Variant image'" />
            </div>
          }
        </div>
        @if (showNavigationButtons()) {
          <button class="next-btn" type="button" (click)="navigationRight()">
            <img src="/assets/images/carousel-arrow-right.svg" alt="Next" />
          </button>
        }
      </div>
    </div>
  }
} @else {
  <!-- When no variant , to make the cards of equal length-->
  <div class="variant-wrapper"></div>
}
